import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';
import { useReactToPrint } from 'react-to-print';

//Servicios
import { GuiasService, UserService, ViniedoService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import Guia from './Guia';
import GuiaPrint from '../guiaPrint/GuiaPrint';
import QRCode from 'react-qr-code';
import { useRef } from 'react';
import { formatCoordinates } from '../../helpers';

//Estilos

function GuiaContainer() {
    const { token, masters, grapesVariety, setGrapesVariety, formatNumber } =
        useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [OpenModal, setOpenModal] = useState(false);
    const [WatchImg, setWatchImg] = useState(false);
    const [Coordinates, setCoordinates] = useState({});
    const [watchGuiaLogs, setWatchGuiaLogs] = useState(false);
    const [GuiaData, setGuiaData] = useState({});

    const Params = useParams();
    const PrintRef = useRef();

    //Booleanos
    const EstadoDestinatario = useMemo(() => {
        return GuiaData?.cabecera?.estado === 1;
    }, [GuiaData]);
    const EstadoCerrada = useMemo(() => {
        return GuiaData?.cabecera?.estado === 2;
    }, [GuiaData]);

    //Elementos HTML
    const QRModal = useMemo(() => {
        return (
            <section>
                <QRCode
                    value={
                        process.env.REACT_APP_URL +
                        RoutesApp.Guias.qr +
                        GuiaData?.cabecera?.token_QR
                    }
                    size={150}
                    level="M"
                />
            </section>
        );
    }, [GuiaData]);

    //Formateador de coordenadas
    useEffect(() => {
        if (Object.keys(GuiaData).length > 0) {
            formatCoordinates(
                GuiaData.cabecera.ubicacion_Viniedo_x,
                GuiaData.cabecera.ubicacion_Viniedo_y
            ).then((res) =>
                setCoordinates({
                    lat: res[0],
                    lon: res[1],
                })
            );
        }
    }, [GuiaData]);

    useEffect(() => {
        //Traemos la guia de BD con el id de la URL
        const getMyGuia = async () => {
            try {
                setLoader(true);

                //Seteamos los parametros de la peticion dependiendo de si es un
                //usuario registrado o uno externo a la app
                let PetitionParams = Params.token
                    ? {
                          token: Params.token,
                      }
                    : {
                          token,
                          id: parseInt(Params.id),
                      };
                //Obtenemos la Guia segun el id que esta en los params
                const Guia = await GuiasService.single(PetitionParams);

                //Si la respuesta es correcta seteamos el estado de la Guia con los datos de la respuesta
                if (Guia) {
                    setGuiaData(Guia.data);

                    if (!Params.token) {
                        const getNombreUsuario =
                            await UserService.getNombreUsuario({
                                token,
                                usuarioId: Guia.data.cabecera.usuario,
                            });

                        if (getNombreUsuario) {
                            setGuiaData({
                                ...Guia.data,
                                ...getNombreUsuario.data,
                            });
                        }
                    }
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const fetchGrapesVariety = async () => {
            try {
                const grapesVarietyData = await ViniedoService.grapesVariety({
                    token: Params.token,
                });

                if (grapesVarietyData) {
                    setGrapesVariety(grapesVarietyData.data);
                }
            } catch (err) {
                return err;
            }
        };

        //Parche para que no se haga una peticion de mas a la api
        if (Object.keys(masters).length) getMyGuia();
        if (Params.token) fetchGrapesVariety();
    }, [Params.id]);

    //Funciones para imprimir la guia
    const handlePrint = useReactToPrint({
        content: () => PrintRef.current,
        onBeforeGetContent: () => console.log(PrintRef.current),
    });

    return loader ? (
        <Spinner />
    ) : (
        <>
            <Guia
                functions={{
                    formatNumber,
                    handlePrint,
                    setOpenModal,
                    setWatchImg,
                    setWatchGuiaLogs,
                }}
                states={{
                    watchGuiaLogs,
                    GuiaData,
                    masters,
                    EstadoCerrada,
                    EstadoDestinatario,
                    WatchImg,
                    Coordinates,
                }}
            />
            <Modal
                title={'Guía'}
                isOpen={OpenModal}
                onClose={() => setOpenModal(!OpenModal)}
            >
                {QRModal}
            </Modal>
            <GuiaPrint
                reference={PrintRef}
                functions={{
                    formatNumber,
                }}
                states={{
                    GuiaData,
                    masters,
                    grapesVariety,
                }}
            />
        </>
    );
}

export default GuiaContainer;
